import React from 'react';
import { Box, SxProps } from '@mui/material';

type WidgetWraperProps = {
    title?: string | Array<string>;
    bgColor?: string;
    sx?: SxProps;
    children: React.ReactNode;
};

const WidgetWraper: React.FC<WidgetWraperProps> = ({ title, bgColor = 'widget.background.card', children, sx }) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '8px',
                backgroundColor: bgColor,
                p: 2,
                boxSizing: 'border-box',
                ...sx,
            }}
        >
            {children}
        </Box>
    );
};

export default WidgetWraper;
